import ServiceUtils from "./service-utils";
import { getEntries, replaceAll, uniq } from "../utils";
import IDraftMap from "../interface/draft-map";
import ServiceUtil from "../enum/service-util";

class EmailDraftSingleton {

    private DraftMaps: IDraftMap[] = [
        { entry: ServiceUtil.Button, tag: 'emailbtn', attrs: ['text', 'url', 'background', 'color'] },
        { entry: ServiceUtil.Gdpr, tag: 'emailreg', attrs: ['positive', 'negative'] },
        { entry: ServiceUtil.Poll, tag: 'emailquestion', attrs: ['positive', 'negative', 'field'] },
        { entry: ServiceUtil.Form, tag: 'emailform', attrs: ['value', 'name', 'background', 'color'] },
        { entry: ServiceUtil.Access, tag: 'emailtable', attrs: ['value', 'name', 'background', 'color'] },
        { entry: ServiceUtil.Sign, tag: 'emailsign', attrs: ['value'] },
        { entry: ServiceUtil.Event, tag: 'emailevent', attrs: ['title', 'from', 'to', 'duration', 'description'] }
    ]

    /* Public Methods */

    public replaceDraftToRaw(source: string): string {
        let res: string = `${source}`;
        this.DraftMaps.forEach((m: IDraftMap) => res = this.draftToRaw(res, m.entry, m.tag, m.attrs));
        return res;
    }

    public replaceRawToDraft(source: string): string {
        let res: string = `${source}`;
        this.DraftMaps.forEach((m: IDraftMap) => res = this.rawToDraft(res, m.entry, m.tag, m.attrs));
        return res;
    }

    /* Private Methods */

    private replaceHtmlTags(original: string, tagName: string, callback: Function): string {
        let result = `${original}`.trim();
        const tags: string[] = this.getHtmlTags(result, tagName);
        tags.forEach((tag: string) => {
            const params: Map<string, string> = this.getHtmlTagAttributes(tag);
            const replace: string = callback(params) || '';
            result = replaceAll(result, tag, replace);
        });
        return result;
    }

    private getHtmlTags(source: string, tagName: string): string[] {
        const regex: RegExp = new RegExp(`\\<${tagName}\\ ((.|[\r\n])*?)\\<\\/${tagName}\\>`, 'g');
        return uniq(getEntries(source, regex));
    }

    private getHtmlTagAttributes(source: string): Map<string, string> {
        let result: Map<string, string> = new Map<string, string>();
        getEntries(source, /(\S*?)\=\"((.|[\r\n])*?)\"/g).forEach((attr: string) => {
            const name: string = attr.split('=')[0];
            result.set(name, attr.slice(name.length + 2, -1));
        });
        return result;
    }

    private rawToDraft(source: string, entry: ServiceUtil, tag: string, props: string[]): string {
        return ServiceUtils.replaceEntries(source, entry, (prop: (string | number)[]) => {
            const attrs: string[] = props.map((attr: string, i: number) => {
                if (prop[i]) {
                    return `${attr}="${encodeURI(prop[i].toString())}"`
                }
                return `${attr}=""`;
            });
            return `<${tag} ${attrs.join(' ')}></${tag}>`;
        });
    }

    private draftToRaw(source: string, entry: ServiceUtil, tag: string, props: string[]): string {
        return this.replaceHtmlTags(source, tag, (p: Map<string, string>) => {
            if (props.length) {
                const attrs: string[] = props.map((attr: string) => decodeURI(p.get(attr) || ''));
                return `[${entry}](${attrs.join(';;')})`;
            } else {
                return `[${entry}]`;
            }
        });
    }

}

const EmailDraft = new EmailDraftSingleton();

export default EmailDraft;